import { render } from "./whatis.vue?vue&type=template&id=27c1b13e"
import script from "./whatis.vue?vue&type=script&lang=js"
export * from "./whatis.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__